import React, { useEffect, useState } from "react";
import { Modal, Button, Form } from "react-bootstrap";
import '../../Assets/CSS/Department.css';
// import { toast, ToastContainer } from "react-toastify";
import toast from "react-hot-toast";
import axios from "axios";
import { format } from "date-fns";

const AddNewDepartment = ({ show, handleClose, handleSave }) => {
    const [loading, setLoading] = useState(false);
    const [employees, setEmployees] = useState([]);
    const todayDate = format(new Date(), "yyyy-MM-dd");
    const [selectedDate] = useState(todayDate);
    const [errors, setErrors] = useState({}); // ✅ store validation errors ;
    const [formData, setFormData] = useState({
        name: "",
        description: "",
        // headId: '',
        // headName: "",
        status: "Active",
        // parentDepartment: "",
        // employeeNames: [],
    });



    // Simple validation
    const validate = () => {
        const newErrors = {};

        if (!formData.name.trim()) newErrors.name = "Department name is required.";
        if (!formData.description.trim())
            newErrors.description = "Description is required.";
        if (!formData.headId) newErrors.headId = "Please select a head of department.";

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleChange = (e) => {
        const { name, value } = e.target;

        setFormData((prev) => ({ ...prev, [name]: value }));

        // Clear error only for this specific field
        setErrors((prevErrors) => ({
            ...prevErrors,
            [name]: "",
        }));
    };

    const fetchWeeklyData = async () => {
        try {
            const url = `${process.env.REACT_APP_BACKEND_URL}/api/v1/emps/list`;
            const response = await fetch(url, {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem("token")}`,
                },
            });

            const data = await response.json();
            const records = Array.isArray(data) ? data : data?.content || [];
            setEmployees(records);

        } catch (error) {
            console.error("Error fetching attendance data:", error);
        }
    };

    // Fetch employees when modal opens
    useEffect(() => {
        if (show) fetchWeeklyData();
    }, [show]);



    const onSave = async () => {
        if (!validate()) return; // ✅ stop if validation fails
        console.log("onSave triggered ✅");
        if (!formData.name || !formData.description) {
            toast.error("Please fill all required fields.");
            return;
        }

        try {
            setLoading(true);
            const token = localStorage.getItem("token");

            // ✅ Build payload according to API spec
            const payload = {
                name: formData.name,
                description: formData.description,
                headId: formData.headId,
                parentDepartmentId: formData.parentDepartmentId
                    ? Number(formData.parentDepartmentId)
                    : 0, // default 0 if not selected
                status: formData.status || "Active",
            };

            console.log("Payload being sent:", payload);

            const response = await axios.post(
                `${process.env.REACT_APP_BACKEND_URL}/api/v1/depts`,
                payload,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        Accept: "*/*",
                        "Content-Type": "application/json",
                    },
                }
            );

            if (response.status === 201 || response.status === 200) {
                toast.success("Department added successfully!");
                handleSave(response.data);
                handleClose();
                setFormData({
                    name: "",
                    description: "",
                    headName: "",
                    status: "Active",
                    parentDepartmentId: "",
                    employeeNames: [],
                });
            } else {
                toast.error("Failed to add department. Try again.");
            }
        } catch (error) {
            console.error("Error while saving department:", error);
            toast.error(error.response?.data?.message || "Server error occurred");
        } finally {
            setLoading(false);
        }
    };

    // const onSave = async () => {

    //     if (!formData.name || !formData.headName || !formData.headEmail) {
    //         toast.error("Please fill all required fields.");
    //         return;
    //     }

    //     try {
    //         setLoading(true);
    //         const token = localStorage.getItem("token"); // or wherever you store it
    //         const response = await axios.post(`${process.env.REACT_APP_BACKEND_URL}/api/v1/depts`,
    //             formData,
    //             {
    //                 headers: {
    //                     Authorization: `Bearer ${token}`
    //                 }
    //             }
    //         );

    //         if (response.status === 201 || response.status === 200) {

    //             toast.success("Department added successfully!");
    //             handleSave(response.data); // Pass data to parent if needed
    //             handleClose();
    //             setFormData({
    //                 name: "",
    //                 description: "",
    //                 headName: "",
    //                 headEmail: "",
    //                 headPhoneNumber: "",
    //                 status: "Active",
    //                 parentDepartment: "",
    //                 totalEmployees: 0,
    //                 employeeNames: [],
    //             });
    //         } else {
    //             toast.error("Failed to add department. Try again.");
    //         }
    //     } catch (error) {
    //         console.error("Error adding department:", error);
    //         toast.error(error.response?.data?.message || "Server error occurred");
    //     } finally {
    //         setLoading(false);
    //     }
    // };

    return (
        <Modal show={show} onHide={handleClose}
            scrollable
            dialogClassName="modal-custom-centered"
        >
            <Modal.Header closeButton>
                <Modal.Title>Add New Department</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form>
                    <Form.Group className="mb-3">
                        <Form.Label>Department Name</Form.Label>
                        <Form.Control
                            type="text"
                            name="name"
                            placeholder="Enter Department Name"
                            value={formData.name}
                            onChange={handleChange}
                        />
                        {errors.name && (
                            <div className="text-danger small mt-1">{errors.name}</div>
                        )}
                    </Form.Group>



                    {/* <Form.Group className="mb-3">
                        <Form.Label>Head of Department</Form.Label>
                        <Form.Control
                            type="text"
                            name="headName"
                            placeholder="Enter head name"
                            value={formData.headName}
                            onChange={handleChange}
                        />
                    </Form.Group> */}
                    {/* <div className="mb-3">
                        <label className="form-label fw-semibold">Head of Department</label>
                        <select
                            className="form-select"
                            name="headId"
                            value={formData.headId}
                            onChange={(e) => {
                                const { name, value } = e.target; // ✅ declare name and value
                                const selected = employees.find((emp) => emp.empId === value);

                                setFormData((prev) => ({
                                    ...prev,
                                    headId: value,
                                    headName: selected?.empFullName || "",
                                    headEmail: selected?.empEmail || "",
                                    headPhoneNumber: selected?.empPhoneNumber || "",
                                }));

                                // ✅ clear the specific field's error
                                setErrors((prevErrors) => ({
                                    ...prevErrors,
                                    [name]: "",
                                }));
                            }}

                        >
                            <option value="">Select Employee</option>
                            {employees.map((emp) => (
                                <option key={emp.empId} value={emp.empId}>
                                    {emp.empName}
                                </option>
                            ))}
                        </select>
                        {errors.headId && (
                            <div className="text-danger small mt-1">{errors.headId}</div>
                        )}
                    </div> */}
                    {/* Head of Department Dropdown */}

                    <div className="mb-3">
                        <label className="form-label fw-semibold">Head of Department</label>
                        <select
                            className="form-select"
                            name="headId"
                            value={formData.headId}
                            onChange={(e) => {
                                const { name, value } = e.target; // ✅ declare name and value
                                const selected = employees.find((emp) => emp.empId === e.target.value);
                                setFormData((prev) => ({
                                    ...prev,
                                    headId: e.target.value,
                                    headName: `${selected?.firstName || ""} ${selected?.lastName || ""}`,
                                    headEmail: selected?.officeEmail || selected?.personalEmail || "",
                                    headPhoneNumber: selected?.mobileNumber || "",
                                }));
                                setErrors((prevErrors) => ({
                                    ...prevErrors,
                                    [name]: "",
                                }));
                            }}
                        >
                            <option value="">Select Employee</option>
                            {employees.map((emp) => (
                                <option key={emp.empId} value={emp.empId}>
                                    {emp.firstName} {emp.lastName}
                                </option>
                            ))}
                        </select>
                        {errors.headId && (
                            <div className="text-danger small mt-1">{errors.headId}</div>
                        )}
                    </div>

                    {/* <Form.Group className="mb-3">
                        <Form.Label>Email</Form.Label>
                        <Form.Control
                            type="email"
                            name="headEmail"
                            placeholder="Enter email"
                            value={formData.headEmail}
                            onChange={handleChange}
                        />
                    </Form.Group>

                    <Form.Group className="mb-3">
                        <Form.Label>Phone</Form.Label>
                        <Form.Control
                            type="text"
                            name="headPhoneNumber"
                            placeholder="Enter phone number"
                            value={formData.headPhoneNumber}
                            onChange={handleChange}
                        />
                    </Form.Group> */}

                    <Form.Group className="mb-3">
                        <Form.Label>Description</Form.Label>
                        <Form.Control
                            as="textarea"
                            rows={4}
                            name="description"
                            placeholder="Enter department description"
                            value={formData.description || ""}
                            onChange={handleChange}
                        />
                        {errors.description && (
                            <div className="text-danger small mt-1">{errors.description}</div>
                        )}
                    </Form.Group>
                    {/* <Form.Group className="mb-3 d-flex justify-content-between p-2"
                        style={{
                            border: '1px solid #DEDEDE', borderRadius: '10px',
                            background: '#D9FFD4'
                        }}>
                        <Form.Label>Status :</Form.Label>
                        <label>{formData.status === "Active" ? "Active" : "Inactive"}</label>
                        <div >
                            <Form.Check
                                type="switch"
                                style={{ color: '#1EA70C' }}
                                id="status-switch"
                                // label={formData.status === "Active" ? "Active" : "Inactive"}
                                checked={formData.status === "Active"}
                                onChange={(e) =>
                                    setFormData({
                                        ...formData,
                                        status: e.target.checked ? "Active" : "Inactive"
                                    })
                                }
                            />
                        </div>
                    </Form.Group> */}




                </Form>
            </Modal.Body>
            <Modal.Footer className="d-flex justify-content-between align-item-center">
                <button onClick={handleClose}
                    className="btn "
                    style={{ border: '1px solid #909090', color: '#909090' }}
                >
                    Close
                </button>
                <button onClick={onSave}
                    className="btn create-btn"
                    style={{}}>
                    Create Department
                </button>
            </Modal.Footer>
        </Modal>
    );
};

export default AddNewDepartment;
